import React, { useState } from 'react';
import { PrivacyPolicyModal } from './PrivacyPolicyModal';
export const Footer = () => {
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  return <footer className="py-8 bg-blue-900 border-t border-gray-200 relative" data-id="element-37">
      {/* Subtle stars background */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-38">
        <div className="w-full h-full bg-repeat" style={{
        backgroundImage: "url('https://www.transparenttextures.com/patterns/stars.png')"
      }} data-id="element-39"></div>
      </div>
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-40">
        <div className="text-center text-gray-200 text-sm" data-id="element-41">
          <p className="mb-4" data-id="element-42">
            Advertorial Note: This article is for informational purposes. The
            content comes from the new book The Last Patriot by Jason Goodman,
            featuring Donald Trump and Charlie Kirk.
          </p>
          <div className="border-t border-gray-600 pt-4 mt-6" data-id="element-43">
            <button onClick={() => setIsPrivacyModalOpen(true)} className="text-gray-300 hover:text-white underline text-sm transition-colors" data-id="element-44">
              Privacy Policy
            </button>
          </div>
        </div>
      </div>
      {/* Privacy Policy Modal */}
      {isPrivacyModalOpen && <PrivacyPolicyModal onClose={() => setIsPrivacyModalOpen(false)} data-id="element-45" />}
    </footer>;
};